module.exports = __webpack_public_path__ + "img/calendar.31b6d0fd.svg";